import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import {Link, Redirect, RouteComponentProps} from "react-router-dom";
import {Alert, Button, message, Typography} from "antd";

import "./SignIn.scss";
import {paths} from "@/routes";
import {ILocationStateReferrerProps} from "@/routes/Routes";
import logo from "@/assets/logo.svg";
import SignInForm from "./SignInForm";
import Store from "@/stores";

// https://www.pluralsight.com/guides/react-router-typescript
export interface ISignInProps extends RouteComponentProps<{}, {}, ILocationStateReferrerProps> {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class SignIn extends React.Component<ISignInProps, any> {
  @observable showStage: boolean;

  constructor(props: ISignInProps) {
    super(props);
    const {stageStore} = this.props.store!;
    this.showStage = !stageStore.isProduction;
  }

  get accountConfirmed(): boolean {
    // When cantamus-auth redirects to sign in after a successful conirmation it adds
    // account_confirmation_success=true parameter
    return new URLSearchParams(this.props.location.search).get("account_confirmation_success") === "true";
  }

  // Referrer location (it has been set in routes/Routes)
  get referrerLocation() {
    return this.props.location.state?.referrer || {pathname: paths.home()};
  }

  onLogoClick(event: React.MouseEvent<HTMLImageElement>) {
    // triple click
    if (event.detail === 3) this.toggleShowEnv();
  }

  async onSubmitSignInForm({email, password}: {email: string; password: string}) {
    const {session} = this.props.store!;
    try {
      await session.signIn({email: email, password: password});
    } catch (errorsResponse) {
      if (errorsResponse?.data?.errors) message.error(errorsResponse.data.errors.join("\n"));
      else message.error("Oops! Something went wrong");
    }
  }

  @action
  toggleShowEnv() {
    this.showStage = !this.showStage;
  }

  public render() {
    const store = this.props.store!;
    if (store.session.isSignedIn) return <Redirect to={this.referrerLocation} />;
    return (
      <div className="SignIn">
        <img className="Logo" src={logo} alt="Logo" onClick={this.onLogoClick} />
        {this.accountConfirmed && (
          <Alert
            className="account-confirmed"
            type="success"
            message="Your account has been confirmed! Please insert your credentials to sign in"
          />
        )}
        <SignInForm onSubmit={this.onSubmitSignInForm} showStage={this.showStage} />
        <Typography.Paragraph style={{marginBottom: 5}}>Don't have an account?</Typography.Paragraph>
        <Link to={paths.signUp()}>
          <Button type="default">Sign up</Button>
        </Link>
      </div>
    );
  }
}
